import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getMyClinicFeatures } from '../services/api';
import { useAuth } from './useAuth';

const ClinicFeaturesContext = createContext({});

export function ClinicFeaturesProvider({ children }) {
  const [features, setFeatures] = useState({});
  const [loaded, setLoaded] = useState(false);
  const { user } = useAuth();

  const reload = useCallback(async () => {
    try {
      const r = await getMyClinicFeatures();
      setFeatures(r.data || {});
    } catch {
      setFeatures({});
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (user) reload();
    else setLoaded(true);
  }, [user, reload]);

  return (
    <ClinicFeaturesContext.Provider value={{ features, loaded, reload, setFeatures }}>
      {children}
    </ClinicFeaturesContext.Provider>
  );
}

export function useClinicFeatures() {
  return useContext(ClinicFeaturesContext);
}
